import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import http from "./api/plugin";
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'

Vue.config.productionTip = false
Vue.prototype.$http = http;
Vue.use(VueViewer);

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
